import { SchematicView } from './schematic';

export function SchematicScreen() {
  return (
    <div className="h-full w-full overflow-hidden p-4 md:p-6">
      <SchematicView />
    </div>
  );
}
